<template>

  <section class="bg-color">
    <div class="container blog-display">
      <div class="inner-blog">
        <div class="row">
          <div class="col-md-8">
            <!-- <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader> -->
            <div class="about-blog">
              <h1 class="blog_title">{{fetchedData.attributes.title}}</h1>
              <!-- <h2 class="blog_subhead">The proposed car ban will affect residents in Barcelona and 39 surrounding municipalities, removing more than 100,000 cars from the roads.</h2> -->
              <h3 class="blog_date_author">{{fetchedData.attributes.event_date | convertDate}} - {{fetchedData.attributes.published_by}}</h3>
              <div class="blog_content">
              <big v-html="this.$options.filters.convertUrlImage(fetchedData.attributes.description)">
              </big>
            </div>
            </div><!-- end about-blog -->
          </div><!-- end col -->
          <div class="col-md-4">
            <popular v-model="popular"></popular>
          </div><!-- end col -->
        </div><!--end row -->
      </div><!-- end inner-blog -->
    </div><!-- end blog-display -->
  </section>

</template>
<script>
import {HTTP} from '../http-common.js'
import * as moment from 'moment-timezone';
import Popular from './Popular.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'blogdetails',
  data () {
    return {
      fetchedData: {
        attributes:{
          title:'',
          event_date:'',
          published_by:'',
          description:''
        }
      },
      popular :'',
      error: false,
      title : null,
      loading:true,
      color:'green',
      size:''
    }
  },
  created: function(){
      this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  filters: {
  	truncate: function(string, value=150) {
      if(string.length <= value) {
       return string;
       }
       else {
           return string.substring(0, value) + '...';
       }

    },
    escape: function(text){
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    },
    convertDate: function(date){
      if(date!='')
      {
        return moment(date).format('MMMM Do, YYYY')
      }
    },
    convertUrlImage:function(text){
      return text.replace("/uploads/filemanager", "https://dev.drishtiair.com/uploads/filemanager");
    }
  },
  methods : {
              fetchData() {
                var itemId = this.$route.params.id;
                var url = 'blog/'+itemId
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.fetchedData = jsonData.data.data
                    this.loading = false
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  },
  components: {
      Popular,
      PulseLoader
  }
}
</script>



// WEBPACK FOOTER //
// BlogDetails.vue?130403b6